<app-side-menu>
  <div class="services-container">
    <!-- Filtros -->
    <div class="filters-section">
      <div class="filters-row">
        <div class="filter-group">
          <label for="categoryFilter" class="form-label">Filtrar por Categoria:</label>
          <select
            id="categoryFilter"
            class="form-select"
            [(ngModel)]="filters.category"
            (change)="applyFilters()">
            <option value="">Todas as categorias</option>
            <option *ngFor="let cat of categories" [value]="cat.value">
              {{ cat.label }}
            </option>
          </select>
        </div>

        <div class="filter-group">
          <label for="statusFilter" class="form-label">Filtrar por Status:</label>
          <select
            id="statusFilter"
            class="form-select"
            [(ngModel)]="filters.status"
            (change)="applyFilters()">
            <option value="">Todos os Status</option>
            <option *ngFor="let status of statuses" [value]="status.name">
              {{ status.name }}
            </option>
          </select>
        </div>

        <div class="filter-actions">
          <button
            type="button"
            class="btn btn-outline-secondary"
            (click)="clearFilters()">
            <i class="fas fa-times me-2"></i>
            Limpar Filtros
          </button>
        </div>
      </div>
    </div>

    <!-- Tabela de Serviços -->
    <div *ngIf="!isLoading && !error && filteredServices.length > 0">
      <app-table
        [title]="tableTitle"
        [columns]="columns"
        [data]="filteredServices"
        [loading]="isLoading"
        [showSearch]="showSearch"
        [searchPlaceholder]="searchPlaceholder"
        [clickable]="clickable"
        [actions]="actions"
        [enableSorting]="true"
        (sortChange)="onSortChange($event)"
        (actionClick)="onActionClick($event)">
        <app-button
          *appHasPermission="'Services.Create'"
          table-header-action
          text="Novo Serviço"
          [color]="'var(--primary-light)'"
          [height]="'42px'"
          className="new-service-btn"
          (buttonClick)="createService()">
        </app-button>
      </app-table>
    </div>

    <!-- Estado Vazio Simples -->
    <div *ngIf="!isLoading && !error && filteredServices.length === 0" class="empty-state-simple">
      <div class="empty-message">
        <i class="fas fa-wrench"></i>
        <p>Nenhum serviço encontrado</p>
      </div>
    </div>

    

<!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

    <app-modal
      [isOpen]="showToggleStatusModal"
      [title]="isSelectedServiceActive ? 'Desativar Serviço' : 'Ativar Serviço'"
      [size]="'md'"
      [closable]="true"
      (close)="closeToggleStatusModal()">
      <div class="report-form">
        <p class="mb-3">
          Deseja realmente
          <strong>{{ isSelectedServiceActive ? 'desativar' : 'ativar' }}</strong>
          o serviço
          <strong>{{ selectedServiceForToggle?.name }}</strong>?
        </p>
      </div>
      <div slot="footer" class="modal-footer-buttons">
        <button type="button" class="btn btn-secondary" (click)="closeToggleStatusModal()">
          Voltar
        </button>
        <button
          type="button"
          [class]="isSelectedServiceActive ? 'btn btn-danger' : 'btn btn-success'"
          [disabled]="isSubmittingToggle"
          (click)="confirmToggleStatus()">
          <i [class]="isSelectedServiceActive ? 'fas fa-ban me-2' : 'fas fa-circle-check me-2'"></i>
          {{ isSubmittingToggle ? 'Processando...' : (isSelectedServiceActive ? 'Desativar Serviço' : 'Ativar Serviço') }}
        </button>
      </div>
    </app-modal>

  </div>
</app-side-menu>
